import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadPrivacyPolicy } from '../utils/legalLoader';
import LandingNav from '../components/shared/LandingNav';
import Seo from '../components/Seo';

const Privacy = () => {
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => { 
    window.scrollTo(0, 0);
    
    loadPrivacyPolicy().then(content => {
      setLegalContent(content);
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ padding: '24px 0' }}>
      <Seo
        title="Privacy Policy | PrecisionTrader"
        description="PrecisionTrader Privacy Policy — how we collect, use, and protect your data."
        canonicalPath="/privacy"
      />
      {/* Navigation (match Landing/Pricing style) */}
      <LandingNav />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 16px' }}>
        {loading ? (
          <div>Loading...</div>
        ) : legalContent ? (
          <>
            <h1 style={{ marginBottom: 8 }}>{legalContent.title}</h1>
            {legalContent.lastUpdated && (
              <div style={{ color: 'var(--text-light)', marginBottom: 24 }}>
                Last Updated: {legalContent.lastUpdated}
              </div>
            )}

            {legalContent.intro && (
              <p style={{ marginBottom: 24 }}>{legalContent.intro}</p>
            )}

            {legalContent.sections.map((section, idx) => (
              <div key={idx} style={{ margin: '24px 0' }}>
                <h3 style={{ marginTop: 24 }}>{section.title}</h3>
                <div style={{ opacity: 0.95 }}>
                  {section.content.map((item, itemIdx) => {
                    if (item.type === 'paragraph') {
                      return <p key={itemIdx}>{item.text}</p>;
                    } else if (item.type === 'bullet') {
                      return (
                        <ul key={itemIdx} style={{ marginLeft: 0, paddingLeft: 20 }}>
                          <li>{item.text}</li>
                        </ul>
                      );
                    } else if (item.type === 'strong') {
                      return <p key={itemIdx}><strong>{item.text}</strong></p>;
                    }
                    return null;
                  })}
                </div>
              </div>
            ))}

            <div style={{ marginTop: 24 }}>
              <Link to="/terms" style={{ color: 'var(--accent)' }}>View Terms of Service</Link>
            </div>
          </>
        ) : (
          <div>Error loading privacy policy</div>
        )}
      </div>
    </div>
  );
};

export default Privacy;
